import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { api, getToken, setToken, removeToken } from './api';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import './App.css';

function App() {
  const [user, setUser]           = useState(null);
  const [isAdmin, setIsAdmin]     = useState(false);
  const [loading, setLoading]     = useState(true);

  // Al montar: validar token guardado
  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api.get('/auth/me')
      .then(data => {
        setUser(data);
        setIsAdmin(data.rol === 'admin');
      })
      .catch(() => {
        removeToken();
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = async (email, password) => {
    const data = await api.post('/auth/login', { email, password });
    const token = data.token || data.accessToken;
    if (!token) throw new Error('Respuesta inválida del servidor');
    setToken(token);
    const userData = data.user || data;
    setUser(userData);
    setIsAdmin(userData.rol === 'admin');
  };

  const handleLogout = async () => {
    try { await api.post('/auth/logout', {}); } catch (_) {}
    removeToken();
    setUser(null);
    setIsAdmin(false);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <img src="/admin/logo_cyker.png" alt="Cyker" className="logo-img-loading" />
        <h1>Panel Administrativo</h1>
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              user && isAdmin ? <Navigate to="/dashboard" /> :
              user && !isAdmin ? (
                <div className="loading-container">
                  <img src="/admin/logo_cyker.png" alt="Cyker" className="logo-img-loading" />
                  <h1>Acceso Denegado</h1>
                  <p style={{ marginBottom: '30px', fontSize: '18px', opacity: '0.9' }}>
                    No tienes permisos de administrador para acceder a este panel.
                  </p>
                  <button
                    onClick={handleLogout}
                    style={{
                      background: 'rgba(255,255,255,0.2)', border: '2px solid rgba(255,255,255,0.3)',
                      color: 'white', padding: '12px 24px', borderRadius: '8px',
                      fontSize: '16px', cursor: 'pointer', transition: 'all 0.3s'
                    }}
                    onMouseOver={e => e.target.style.background = 'rgba(255,255,255,0.3)'}
                    onMouseOut={e  => e.target.style.background = 'rgba(255,255,255,0.2)'}
                  >
                    Cerrar Sesión
                  </button>
                </div>
              ) :
              <Login onLogin={handleLogin} />
            }
          />
          <Route
            path="/dashboard/*"
            element={user && isAdmin ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/"
            element={<Navigate to={user && isAdmin ? '/dashboard' : '/login'} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
